import 'mapbox-gl/dist/mapbox-gl.css';

import { SecondaryNav } from '@/components';
import { usePathSet } from '@/hooks/usePathSet';
import { SignedInPageLayout } from '@/layout/signed-in-page';
import { useMenuItems } from '@/pages/shared/hooks/useMenuItems';
import { usePlot } from '@/pages/shared/hooks/usePlot';
import { buildPath } from '@/utils/buildPath';

import { PlotInteractiveMap } from './components/PlotInteractiveMap';

export const InteractiveMapPage = () => {
  const menuItems = useMenuItems();
  const pathSet = usePathSet();

  const plot = usePlot().data;
  const projectId = plot.project ?? plot.project_id ?? '';

  return (
    <SignedInPageLayout items={menuItems} withCustomContentContainer className='h-full'>
      <SecondaryNav
        title={plot.name}
        backPath={buildPath(pathSet.plot, {
          pathParams: { projectId, plotId: plot.id },
        })}
      />
      <PlotInteractiveMap plot={plot} />
    </SignedInPageLayout>
  );
};
